export default {
  path: "/user/cpa/ferias",
  component: () => import("@/views/user/cpa/ferias/FeriasLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "ferias-dashboard",
      component: () => import("@/views/user/cpa/ferias/FeriasDashboard.vue"),
    },
    {
      path: "nueva",
      name: "ferias-nueva",
      component: () => import("@/views/user/cpa/ferias/FairEditorView.vue"),
    },
    {
      path: "emprendedores",
      name: "ferias-emprendedores",
      component: () => import("@/views/user/cpa/ferias/EntrepreneursView.vue"),
    },
    {
      path: "empresas-sponsors",
      name: "ferias-empresas-sponsors",
      component: () =>
        import("@/views/user/cpa/ferias/SponsorCompaniesView.vue"),
    },
    {
      path: ":fairId",
      name: "ferias-editar",
      component: () => import("@/views/user/cpa/ferias/FairEditorView.vue"),
      props: true,
    },
    {
      path: ":fairId/postulaciones",
      name: "ferias-postulaciones",
      component: () => import("@/views/user/cpa/ferias/ApplicationsView.vue"),
      props: true,
    },
    {
      path: ":fairId/stands",
      name: "ferias-stands",
      component: () => import("@/views/user/cpa/ferias/StandsAdminView.vue"),
      props: true,
    },
    {
      path: ":fairId/sponsors",
      name: "ferias-sponsors",
      component: () => import("@/views/user/cpa/ferias/FairSponsorsView.vue"),
      props: true,
    },
    {
      path: ":fairId/difusion",
      name: "ferias-difusion",
      component: () => import("@/views/user/cpa/ferias/FairDiffusionView.vue"),
      props: true,
    },
  ],
};
